import * as React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import KPDropdown from '../../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';

class SelectVehicle extends React.PureComponent<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            nextDisabled: true,
            selection: null,
            products: [],
            renderDropdown: true,
        };

        this.handleLstVehicleChange = this.handleLstVehicleChange.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
    }

    async componentDidMount() {
        await this.setState({ renderDropdown: false });
        let products = [ { id: "0", productName: "Car", description: "Not on this list" } ];
        let vehicles = this.props.cart.products.filter(x => x.name === "Car");
        
        await vehicles.forEach(item => {
            products.push({ id: item.riskItemId, productName: item.name, description: item.description });
        });

        let selectedItem: any[] = [];
        if (this.props.sales.codeRedSelectedRiskitem !== "") {
            selectedItem = products.filter(x => x.id === this.props.sales.codeRedSelectedRiskitem);
        }

        await this.setState({ products: products, selection: selectedItem[0], renderDropdown: true });

        await this.checkSubmit();
    }

    async handleNextStep() {
        await this.checkSubmit();
        if (!this.state.nextDisabled) {
            let payload = { codeRedSelectedRiskitem: this.state.selection.id }
            await this.props.dispatchAction(setQuoteData(payload));
            await this.props.dispatchAction(handleNextStep());
        }
    }

    async handleLstVehicleChange(e: any) {
        let selectedItem = this.state.products.filter(x=> x.id === e)
        await this.setState({ selection: selectedItem[0] });
        await this.checkSubmit();
    }

    async checkSubmit() {
        this.setState({ nextDisabled: this.state.selection === null });
    }

    public render() {
        return (
            <div className="container expand-dropdown">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <p className="text-center">
                            Select a car that’s on your policy or select ‘Not on this list’ to fill in your car info manually
                        </p>

                        {this.state.renderDropdown &&
                            <KPDropdown
                                id={"lstVehicles"}
                                className={"ssp-popup-dropdown"}
                                label={"Select a vehicle"}
                                showLabelAfterSelection={true}
                                showLabelInside={false}
                                showLabelOutside={true}
                                labelAfterSelection={"Select a vehicle"}
                                data={this.state.products}
                                handleSelection={(e) => this.handleLstVehicleChange(e)}
                                selectedValue={this.state.selection}
                            />
                        }
                    </div>
                </div>
                <div className="justify-content-center mt-20px">
                    <div className="sales-button-holder">
                        <Button className="btn btn-solid-red button-sales-height" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</Button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        cart: state.cart,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectVehicle);